import { render } from "./AppDetailsModal.vue?vue&type=template&id=2fb9bf20&scoped=true"
import script from "./AppDetailsModal.vue?vue&type=script&lang=js"
export * from "./AppDetailsModal.vue?vue&type=script&lang=js"

import "./AppDetailsModal.vue?vue&type=style&index=0&id=2fb9bf20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb9bf20"]])

export default __exports__